import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Linkedin, ArrowUpRight, Leaf } from 'lucide-react'
import { companyInfo, navigation, services } from '../data/pages'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-earth-900 text-earth-300">
      <div className="bg-gradient-to-r from-blossom-800 via-blossom-700 to-prime-800">
        <div className="container-wide section-padding py-12 lg:py-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <h2 className="text-2xl lg:text-3xl font-bold text-white mb-2">Ready for a cleaner future?</h2>
              <p className="text-blossom-100">Get your free, no-obligation quote today. Same-day response guaranteed.</p>
            </div>
            <Link to="/contact" className="btn-primary bg-white text-blossom-700 hover:bg-earth-50 shrink-0">
              Get a Free Quote <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>

      <div className="container-wide section-padding py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-blossom-500 to-prime-600 rounded-xl flex items-center justify-center">
                <span className="text-lg font-black text-white">BP</span>
              </div>
              <div><span className="text-lg font-bold text-white">Blossom<span className="text-blossom-400">Prime</span></span></div>
            </Link>
            <p className="text-earth-400 text-sm leading-relaxed mb-6">{companyInfo.description}</p>
            <div className="flex items-center gap-2 text-blossom-400 text-sm"><Leaf className="w-4 h-4" /><span>Carbon-Neutral Operations</span></div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.href}><Link to={item.href} className="text-earth-400 hover:text-blossom-400 transition-colors text-sm">{item.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.id}><Link to="/services" className="text-earth-400 hover:text-blossom-400 transition-colors text-sm">{service.shortTitle}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blossom-500 shrink-0 mt-0.5" />
                <span className="text-earth-400 text-sm">{companyInfo.address.street}<br />{companyInfo.address.city}, {companyInfo.address.postcode}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-blossom-500 shrink-0" />
                <a href={`tel:${companyInfo.contact.phone.replace(/\s/g, '')}`} className="text-earth-400 hover:text-blossom-400 transition-colors text-sm">{companyInfo.contact.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blossom-500 shrink-0" />
                <a href={`mailto:${companyInfo.contact.email}`} className="text-earth-400 hover:text-blossom-400 transition-colors text-sm">{companyInfo.contact.email}</a>
              </li>
              <li>
                <a href={companyInfo.social.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-earth-400 hover:text-blossom-400 transition-colors text-sm">
                  <Linkedin className="w-5 h-5 text-blossom-500 shrink-0" />LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-earth-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-earth-500 text-sm">© {currentYear} {companyInfo.name}. All rights reserved.</p>
          <div className="flex items-center gap-6 text-sm">
            <a href={`mailto:${companyInfo.contact.email}?subject=Privacy%20Policy%20Enquiry`} className="text-earth-500 hover:text-earth-300 transition-colors">Privacy Policy</a>
            <a href={`mailto:${companyInfo.contact.email}?subject=Terms%20of%20Service%20Enquiry`} className="text-earth-500 hover:text-earth-300 transition-colors">Terms of Service</a>
            <a href={`mailto:${companyInfo.contact.email}?subject=Cookie%20Policy%20Enquiry`} className="text-earth-500 hover:text-earth-300 transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
